import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldsSection from '../../../../../../features/components/Form/FieldsSection'
import FieldRow from '../../../../../../features/components/Form/FieldsSection/FieldRow'
import Field from '../../../../../../components/Form/Field'
import ControllerMemberContentReusableFields from './ControllerMemberContentReusableFields'

import { EMAIL, ROLE, roleOptions } from '../fields'

import useCommonStyles from '../../../../../../styles/common/stepForms'
import useStyles from './styles'

const ControllerInviteCreateFormContent = ({ formik }) => {
  const { t } = useTranslation()

  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { values } = formik

  return (
    <div className={commonClasses.stepBody}>
      <FieldsSection title={t('User email')}>
        <FieldRow
          title={t('Email address')}
          description={t('This user will receive an email inviting them to this account.')}
        >
          <Field placeholder={t('email address')} formik={formik} name={EMAIL} />
        </FieldRow>
        <FieldRow
          title={t('Role')}
          description={
            <>
              <div className={classes.roleDescription}>
                <b>{t('Admin')}</b>
                {t(': Full access')}
              </div>
              <div className={classes.roleDescription}>
                <b>{t('Manager')}</b>
                {t(': Full campaign management access')}
              </div>
              <div className={classes.roleDescription}>
                <b>{t('Reporting')}</b>
                {t(': Reporting only')}
              </div>
              <div className={classes.roleDescription}>
                <b>{t('Buyer')}</b>
                {t(': Reporting for a buyer’s specific brand category')}
              </div>
            </>
          }
        >
          <Field placeholder={t('Select Role')} formik={formik} name={ROLE} options={roleOptions} />
        </FieldRow>
        <ControllerMemberContentReusableFields formik={formik} controllerMemberRole={values[ROLE]} />
      </FieldsSection>
    </div>
  )
}

export default ControllerInviteCreateFormContent
